import { Filter, JobPortalFilterType } from 'jobs.types';
import { BEFRISTUNG_ATTRIBUTE_ID, HOMEOFFICE_ATTRIBUTE_ID } from '../constants';

export const ADDITIONALS_KEY = 'additionals';

const updateSearchParameters = (
  type: JobPortalFilterType,
  key: string,
  value: string | string[],
  filter: Filter,
  setFilter: (filter: Filter) => void,
) => {
  const newFilter = { ...filter };

  if (key === ADDITIONALS_KEY) {
    if (!value.length) {
      delete newFilter.search[HOMEOFFICE_ATTRIBUTE_ID];
      delete newFilter.search[BEFRISTUNG_ATTRIBUTE_ID];
    }

    if (!value.includes('remote')) {
      delete newFilter.search[HOMEOFFICE_ATTRIBUTE_ID];
    }

    (value as string[]).forEach((v) => {
      if (v === 'remote') {
        newFilter.search[HOMEOFFICE_ATTRIBUTE_ID] = ['1'];
      } else {
        newFilter.search[BEFRISTUNG_ATTRIBUTE_ID] = (value as string[]).filter(
          (v1) => v1 !== 'remote',
        );
      }
    });
  }

  if (!value?.length || value[0] === '0' || value[0] === '100') {
    delete newFilter[type][key];
  } else if (!(key === ADDITIONALS_KEY)) {
    newFilter[type][key] = value;
  }

  if (type === 'search') {
    // if search, update jobAbo criterias too
    const jobAbo = { ...newFilter.search };
    delete jobAbo.limit;
    delete jobAbo.sort;

    newFilter.jobAbo = jobAbo;
  }

  setFilter(newFilter);
};

export default updateSearchParameters;
